// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4588":"css/app-theme","8252":"css/app"}[chunkId] + ".css";
};